/** Per-marketplace Seller Center order-detail URL builders, keyed like MARKETPLACE_STATUS_LABEL. */
const SELLER_CENTER_URL: Record<string, (saleOrderId: string) => string> = {
  shopee: (id) => `https://seller.shopee.co.th/portal/sale/order/${id}`,
  lazada: (id) => `https://sellercenter.lazada.co.th/apps/order/detail?tradeOrderId=${id}`,
  tiktok: (id) => `https://seller-th.tiktok.com/order/detail?order_no=${id}`,
};

/** Seller Center deep link for an order, or null for an unknown marketplace. */
export function sellerCenterUrl(mkp: string, saleOrderId: string): string | null {
  return SELLER_CENTER_URL[mkp]?.(saleOrderId) ?? null;
}
